

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import { dayjs, DTW_FORMAT_JA_WO_YM, DT_FORMAT_JA, DW_FORMAT_JA, T_FORMAT_JA } from '../../../../src_server/common/momentExtends';
import { DaLessonsService } from '../../../biz/remote/DaLessonsService';
import { Session } from '../../../utils/Session';
import { LessonDTO } from '../../../../src_server/entity/dto/LessonDTO';
import { ShiftTable } from '../../../../src_server/entity/generated/ShiftTable';
import { Teacher } from '../../../../src_server/entity/generated/Teacher';
import { DaTeacher } from '../../../../src_server/entity/generated/DaTeacher';
import { LessonStates } from '../../../../src_server/entity/master/LessonStates';
import { routeHelperOpenNewTab } from '../../../utils/routeHelper';
import { MessageDialog } from '../../../utils/MessageDialog';
import { LessonServiceFront } from '../../../biz/LessonServiceFront';
import { reportSend } from '../../../biz/reportSendLogic';

class CourseLessons {
  shift_table: ShiftTable = new ShiftTable();
  teacher: Teacher = new Teacher();
  da_teacher: DaTeacher = new DaTeacher();
  lessons: LessonDTO[] = [];
}

@Component({
  components: { CommonDialog },
  filters: {
    yesNoFormat: (state: boolean) => {
      return state ? '掲載OK' : '不可';
    },
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DTW_FORMAT_JA_WO_YM);
    },
    timeFormat: (dt: Date) => {
      return dayjs(dt).format(T_FORMAT_JA);
    },
  },
})
export default class DaAllDayLessonDialog extends Vue {
  private title = '';
  private targetDate = new Date();

  private list: LessonDTO[] = [];
  private courseLessons: CourseLessons[] = [];

  private canUpPhotoCss(state: boolean) {
    const result = [];
    result.push('badge');
    result.push('badge-pill');
    result.push(state ? 'badge-info' : 'badge-secondary');
    return result;
  }

  private stateCss(state: string) {
    return LessonStates.getBadgeClassByState(state);
  }
  private state(state: string) {
    return LessonStates.getDaState(state);
  }

  private isCommit(state: string) {
    return LessonStates.COMMIT === state;
  }

  private isAlready(state: string) {
    return LessonStates.ALREADY === state;
  }

  private isReserevation(state: string) {
    return LessonStates.RESERVATION === state;
  }
  private canCancel(state: string) {
    return LessonStates.RESERVATION === state || LessonStates.COMMIT === state;
  }

  private async cancelLesson(row: LessonDTO) {
    const biz = new LessonServiceFront();
    row.commit = true;
    await biz.cancel(row.lessons.class_id!, (class_id) => {
      // データをリロード
      this.loadData(this.targetDate);
    });
  }

  private async commitLesson(lessons: LessonDTO) {
    // MessageDialog.
    const isOK = await MessageDialog.confirm(`${lessons.student?.nickname}さんの${dayjs(lessons.lessons?.start_dt).format(DT_FORMAT_JA)}開始の予約を確定します。よろしいですか？`);

    if (isOK) {
      const biz = new DaLessonsService();
      lessons.commit = true;
      const response = await biz.reservationCommit(lessons.lessons, Session.getSessionBuildingId());
      if (response.hasError) {
        MessageDialog.alert(response.errorDescription);
        return;
      }
      await MessageDialog.alert(`${dayjs(lessons.lessons.start_dt).format(DT_FORMAT_JA)}の予約を確定しました`);
      // データをリロード
      this.loadData(this.targetDate);
    }
  }

  private report(class_id: number) {
    reportSend(this, class_id, 'report');
    // routeHelper(this, 'DaAdminDailyReportPage', { class_id: `${class_id}` });
  }
  private reportDoc(class_id: number) {
    reportSend(this, class_id, 'doc');
    // routeHelper(this, 'DaAdminDailyReportDocPage', { class_id: `${class_id}` });
  }

  private async loadData(date: Date) {
    const biz = new DaLessonsService();
    const response = await biz.getLessonInTheDay(date, Session.getSessionBuildingId());
    this.list = response.data;
    this.courseLessons = this.list.reduce((p: CourseLessons[], c: LessonDTO) => {
      // 新規の配列要素作成関数
      function buildNew(pre: CourseLessons[]) {
        const newCourseLesson = new CourseLessons();
        newCourseLesson.shift_table = c.shift_table!;
        newCourseLesson.teacher = c.teacher!;
        newCourseLesson.da_teacher = c.da_teacher!;
        if (c.lessons.class_id) {
          newCourseLesson.lessons = [c];
        }
        pre.push(newCourseLesson);
        return pre;
      }

      // 初回は新規作成
      if (p.length === 0) {
        p = buildNew(p);
      } else {
        // guard
        // if (!p[p.length] || !c.shift_table) return p;
        const lastItem = p[p.length - 1];
        if (lastItem?.shift_table?.shift_table_id == c.shift_table?.shift_table_id) {
          // 最後のシフトIDと同じならリストに追加
          lastItem.lessons.push(c);
          // console.log('最後のシフトIDと同じならリストに追加', lastItem?.shift_table?.shift_table_id, c.shift_table?.shift_table_id);
        } else {
          // 最後のシフトIDと違えば新規
          p = buildNew(p);
          // console.log('最後のシフトIDと違えば新規', lastItem?.shift_table?.shift_table_id, c.shift_table?.shift_table_id);
        }
      }
      return p;
    }, [] as CourseLessons[]);
  }

  /**
   * ダイアログを開く
   */
  public async show(date: Date) {
    this.title = `${dayjs(date).format(DW_FORMAT_JA)}の状況`;
    this.targetDate = date;
    this.loadData(date);
    (this.$refs['all_day_lesson_dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['all_day_lesson_dialog'] as CommonDialog).hide();
  }

  printAll() {
    const class_ids = this.courseLessons
      .map((c) => c.lessons)
      .flat(1)
      .filter((l) => l.lessons.reservation_state === LessonStates.ALREADY)
      .map((l) => l.lessons.class_id);
    routeHelperOpenNewTab(this, 'ReportPrintPage', { class_id: class_ids.join(',') });
  }
}
